import React from "react";
import ReactDOM from "react-dom";
import { ScenarioElement } from "../../../../model/playerConfiguration/ScenarioElement";
import { ScenarioPath } from "../../../../model/scenarioPath/ScenarioPath";
import { TimeFormatter } from "../../../../utils/TimeFormatter";
import { PartComponent } from "../common/PartComponent";
import { SliderComponent } from "../common/SliderComponent";
import { TooltipComponent } from "../common/TooltipComponent";

import "@styles/c-mobileSeekbar.scss";

interface Props {
  isDisabled?: boolean;
  isHidden: boolean;
  scenarioPath: ScenarioPath;
  totalTime: number;
  ellapsedTime: number;
  bufferedTime: number;
  onSeekTo: (time: number) => void;
  onJumpToScenarioElement: (scenarioElement: ScenarioElement, progress: number) => void;
  onSliderInteractionStarted: () => void;
  onSliderInteractionEnded: (wasChanging: boolean) => void;
}

interface State { }

export class MobileSeekbarComponent extends React.Component<Props, State> {

  private slider: SliderComponent;
  private sliderHtml: HTMLElement;

  render() {
    const {
      isDisabled,
      isHidden,
      scenarioPath,
      totalTime,
      ellapsedTime,
      bufferedTime,
      onSeekTo,
      onJumpToScenarioElement,
      onSliderInteractionStarted,
      onSliderInteractionEnded
    } = this.props;

    const progress = ellapsedTime / totalTime;
    const bufferingProgress = bufferedTime / totalTime;

    return (
      <div
        className="c-mobileSeekbar"
      >
        {isDisabled && <div className="c-mobileSeekbar__disabledCover" />}
        <div className={`c-mobileSeekbar__tooltip ${isHidden ? "c-mobileSeekbar__tooltip--hidden" : ""}`}>
          <TooltipComponent
            x={this.calculateTooltipX()}
            y={0}
            text={TimeFormatter.format(ellapsedTime)}
            isDesktop={false}
            style="accent"
          />
        </div>
        <div className="c-mobileSeekbar__seekbar">
          {scenarioPath.displayedPastParts.map((part) => (
            <PartComponent
              key={part.id}
              part={part}
              onPartClicked={(scenarioElement, jumpProgress) => onJumpToScenarioElement(scenarioElement, jumpProgress)}
            />
          ))}
          <SliderComponent
            ref={(element) => this.slider = element}
            className="c-mobileSeekbar__slider"
            style={{
              flexBasis: `${scenarioPath.currentPart.size}%`
            }}
            value={progress}
            isHandleAlwaysVisible={true}
            secondaryValue={bufferingProgress}
            onSliderInteraction={(value, isChanging) => isChanging && onSeekTo(value * totalTime)}
            onChangingSliderInteractionStarted={onSliderInteractionStarted}
            onSliderInteractionEnded={onSliderInteractionEnded}
          />
          {scenarioPath.displayedFutureParts.map((part) => (
            <div
              className="c-mobileSeekbar__part"
              style={{
                flexBasis: `${part.size}%`
              }}
              key={part.id}
            />
          ))}
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.sliderHtml = ReactDOM.findDOMNode(this.slider) as HTMLElement;
  }

  private calculateTooltipX() {
    if (!this.slider) {
      return 0;
    }

    const { ellapsedTime, totalTime } = this.props;
    const progress = ellapsedTime / totalTime;

    const sliderBoundingRect = this.sliderHtml.getBoundingClientRect();

    return sliderBoundingRect.left + sliderBoundingRect.width * progress;
  }

}
